import type React from 'react';

import { ProgressStepper, Text } from '@change/ds-core-ui';

import { Html } from '#src/app/shared/components/html';
import { TrackExperimentExposure } from '#src/app/shared/components/tracking';

import { ComboStory } from './components/ComboStory';
import { HeroFeed } from './components/HeroFeed';
import { ImpactBox } from './components/ImpactBox';
import { PetitionMedia } from './components/PetitionMedia';
import { PromoteOrShareActions } from './components/PromoteOrShareActions';
import { ShareFirstSocialStarterCard } from './components/ShareFirstSocialStarterCard';
import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC<EmptyProps> = () => {
	const {
		data: {
			heading,
			subHeading1,
			heroFeed,
			pageTitle,
			showImpactBox,
			hideMediaSlot,
			socialStarterShareFirst,
			psfShareFirstSocialStarterExperiment,
			psfOgTextExperiment,
			petitionId,
		},
	} = usePageBody();

	return (
		<div className="mx-auto max-w-[610px]">
			{/* Only set on the Social Starter route (see usePageBody) — combo never fires this exposure.
			    Fires for every arm, including control (where the card below never mounts). resetKeys
			    re-fires per petition since PageBody isn't remounted on SPA petition nav. */}
			{psfShareFirstSocialStarterExperiment && (
				<TrackExperimentExposure experiment={psfShareFirstSocialStarterExperiment} resetKeys={[petitionId]} />
			)}
			{/* EXPERIMENT: psf_og_text_experiment — remove with experiment cleanup. No-op on Social Starter,
			    whose static control is untreated. */}
			<TrackExperimentExposure experiment={psfOgTextExperiment} resetKeys={[petitionId]} />
			{!hideMediaSlot && <PetitionMedia />}
			<div className="bg-background-base elevation-elevated relative rounded-2xl py-7 md:py-9">
				<div className="flex flex-col gap-7 px-6 md:gap-9 md:px-10">
					<div className="flex flex-col justify-center gap-3 pb-3">
						{pageTitle && <Text className="text-center">{pageTitle}</Text>}
						<ProgressStepper currentStepNumber={2} numberOfSteps={3} />
					</div>
					<div className="flex flex-col" data-qa="description">
						<Text variant="heading" as="h1" className="m-0 mb-3 md:mb-4">
							{heading}
						</Text>
						{socialStarterShareFirst ? (
							<ShareFirstSocialStarterCard />
						) : (
							<Html as="div" html={subHeading1} className="text-typography-strong mb-7 md:mb-9 md:text-lg" />
						)}

						<ComboStory />

						{showImpactBox && (
							<ImpactBox className="mt-4">
								{heroFeed.items.length > 0 && <HeroFeed items={heroFeed.items} data-qa="hero-feed-mobile-impact" />}
							</ImpactBox>
						)}
					</div>

					<PromoteOrShareActions />
				</div>
			</div>
		</div>
	);
};
